/** Build the official "How to cite" string from article metadata. */
export function buildCitation(article) {
  if (!article) return "";
  const authors = (article.authors || []).filter((a) => a.last_name || a.first_name);
  // First 3 authors: full first name + full first last name, second last name as initial.
  const formatName = (a) => {
    const base = [a.first_name, a.last_name].filter(Boolean).join(" ").trim();
    const sec = (a.second_last_name || "").trim();
    return sec ? `${base} ${sec[0]}.` : base;
  };
  const names = authors.slice(0, 3).map(formatName);
  if (authors.length > 3) names.push("et al.");
  const authorPart = names.join(", ");
  const title = (article.title || "").trim().replace(/\.$/, "");
  const journal = "Clin Surg Rev";
  const year = article.year || "";
  const vol = article.volume || "";
  const iss = article.issue || "";
  const pages = article.pages || article.article_number || "";
  const doi = article.doi || "";
  let cite = "";
  if (authorPart) cite += authorPart.endsWith(".") ? `${authorPart} ` : `${authorPart}. `;
  if (title) cite += `${title}. `;
  cite += `${journal}.`;
  if (year) cite += ` ${year}`;
  if (vol) cite += `;${vol}`;
  if (iss) cite += `(${iss})`;
  if (pages) cite += `:${pages}`;
  cite += ".";
  if (doi) cite += ` doi: ${doi}`;
  return cite.trim();
}

/** Parse a table pasted from clipboard (Word, Excel, Google Docs).
 * Supports HTML <table>...</table>, tab-separated text and newline-separated rows.
 * Returns a 2D array of strings, or null if no table data detected.
 */
export function parsePastedTable(clipboardData) {
  const html = clipboardData.getData("text/html");
  if (html && /<table/i.test(html)) {
    try {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const table = doc.querySelector("table");
      if (table) {
        const rows = [];
        table.querySelectorAll("tr").forEach((tr) => {
          const cells = [];
          tr.querySelectorAll("th,td").forEach((cell) => {
            cells.push((cell.textContent || "").replace(/\s+/g, " ").trim());
          });
          if (cells.length) rows.push(cells);
        });
        if (rows.length) return rows;
      }
    } catch {}
  }
  const text = clipboardData.getData("text/plain");
  if (text && /[\t\n]/.test(text)) {
    const lines = text.replace(/\r/g, "").split("\n").filter((l) => l.length > 0);
    if (lines.length === 0) return null;
    const rows = lines.map((l) => (l.includes("\t") ? l.split("\t") : [l]));
    const maxCols = Math.max(...rows.map((r) => r.length));
    return rows.map((r) => [...r, ...Array(maxCols - r.length).fill("")]);
  }
  return null;
}
